// Какую полосу показать над страницей. Наверху всегда одна полоса, связь важнее
// баланса: без связи кассиру важнее знать, что заказы не обновляются.
// Без импортов и в CommonJS, чтобы тест запускался голым node, как у refresh-registry.

// Короткие обрывы сокета (перезапуск сервера, смена сети) полосой не показываем
const SERVER_LOST_DELAY_MS = 5000
// Сколько висит зелёное «Связь восстановлена»
const RESTORED_SHOW_MS = 3000
// На оформлении и редактировании заказа и на кухонном экране полос над страницей нет:
// ни про связь, ни про баланс - они перекрывали бы степпер заказа (владелец, 2026-10-21)
const CONNECTION_HIDDEN_LAYOUTS = ['order-layout', 'edit-order-layout', 'kitchen-layout']
// Быстрый просмотр заказа живёт на дефолтном layout'е, но это тоже экран заказа:
// полоса уходила под панель «Ваш заказ»
const CONNECTION_HIDDEN_ROUTES = ['fastOrderEdit']

// socketLostBar - показывать ли «Заказы обновляются с задержкой» по потере сокета;
// в приложении берётся из env (constants/connection-bar.js), по умолчанию выключено
function connectionMode ({ online, loggedIn, wsConnected, disconnectedSince, serverUnavailable, now, socketLostBar = true }) {
  if (!online) {
    return 'offline'
  }

  // До входа сокет не подключается и сторож не ходит - их состояние ничего не значит
  if (!loggedIn) {
    return null
  }

  // Сервер не ответил на три пробы сторожа подряд - важнее состояния сокета
  if (serverUnavailable) {
    return 'api'
  }

  if (socketLostBar && !wsConnected && now - disconnectedSince >= SERVER_LOST_DELAY_MS) {
    return 'server'
  }

  return null
}

// Layout не входит в connectionMode: переход на страницу заказа не должен выглядеть
// как восстановление связи. Скрытие решается здесь
function topBarMode ({ connection, restored, expiring, connectionHidden = false }) {
  if (!connectionHidden) {
    if (connection) {
      return connection
    }

    if (restored) {
      return 'restored'
    }
  }

  return expiring ? 'expiring' : null
}

function connectionBarHidden (layout, routeName) {
  return CONNECTION_HIDDEN_LAYOUTS.includes(layout) || CONNECTION_HIDDEN_ROUTES.includes(routeName)
}

function expiringBarVisible ({ paymentAccount, isSuperAdmin, layout, routeName }) {
  if (isSuperAdmin || connectionBarHidden(layout, routeName)) {
    return false
  }

  // Весь срок отсрочки, пока по её концу грозит блокировка: без рубильника endsAt нет
  const promisedPayment = paymentAccount.promisedPayment || {}
  if (promisedPayment.active) {
    return Boolean(promisedPayment.endsAt)
  }

  return Boolean(paymentAccount.expiringSoon)
}

module.exports = {
  SERVER_LOST_DELAY_MS,
  RESTORED_SHOW_MS,
  connectionMode,
  topBarMode,
  expiringBarVisible,
  connectionBarHidden,
}
